import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
const API_URL = process.env.REACT_APP_API_URL;
const PasswordSettings = () => {
    const { t } = useTranslation();
    const { token } = useAuth();
    const [passwords, setPasswords] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        setPasswords(p => ({ ...p, [e.target.name]: e.target.value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); setMessage('');
        if (passwords.newPassword !== passwords.confirmPassword) {
            setError(t('error_passwords_do_not_match'));
            return;
        }
        try {
            const response = await fetch(`${API_URL}/api/dashboard/profile/change-password`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ currentPassword: passwords.currentPassword, newPassword: passwords.newPassword })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(t(data.messageKey) || t('error_password_update'));
            
            setMessage(t('success_password_updated'));
            setPasswords({ currentPassword: '', newPassword: '', confirmPassword: '' }); // Formu temizle
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div className="profile-form-container">
            <h2>{t('password_settings', 'Parola Ayarları')}</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group-auth floating-label">
                    <input id="currentPassword" name="currentPassword" type="password" value={passwords.currentPassword} onChange={handleChange} required placeholder=" " />
                    <label htmlFor="currentPassword">{t('current_password', 'Mevcut Parola')}</label>
                </div>
                <div className="form-group-auth floating-label">
                    <input id="newPassword" name="newPassword" type="password" value={passwords.newPassword} onChange={handleChange} required placeholder=" " />
                    <label htmlFor="newPassword">{t('new_password', 'Yeni Parola')}</label>
                </div>
                <div className="form-group-auth floating-label">
                    <input id="confirmPassword" name="confirmPassword" type="password" value={passwords.confirmPassword} onChange={handleChange} required placeholder=" " />
                    <label htmlFor="confirmPassword">{t('confirm_new_password', 'Yeni Parola (Tekrar)')}</label>
                </div>
                {message && <p className="auth-success">{message}</p>}
                {error && <p className="auth-error">{error}</p>}
                <button type="submit" className="cta-button">{t('update_password', 'Parolayı Güncelle')}</button>
            </form>
        </div>
    );
};
export default PasswordSettings;